import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const Group = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon height={22} width={22} {...other}>
			<path
				d="M7.875 9C10.3605 9 12.375 6.9852 12.375 4.5C12.375 2.0148 10.3605 0 7.875 0C5.38945 0 3.375 2.0148 3.375 4.5C3.375 6.9852 5.38945 9 7.875 9ZM7.875 1.6875C9.42574 1.6875 10.6875 2.94926 10.6875 4.5C10.6875 6.05074 9.42574 7.3125 7.875 7.3125C6.32426 7.3125 5.0625 6.05039 5.0625 4.5C5.0625 2.94926 6.32461 1.6875 7.875 1.6875ZM9.65742 10.6875H6.09258C2.72707 10.6875 0 13.4156 0 16.7801C0 17.4551 0.545625 18 1.21852 18H14.5301C15.2051 18 15.75 17.4551 15.75 16.7801C15.75 13.4156 13.0219 10.6875 9.65742 10.6875ZM1.71246 16.3125C1.94695 14.1012 3.82148 12.375 6.09258 12.375H9.65742C11.9289 12.375 13.7742 14.1022 14.0379 16.3125H1.71246ZM16.8434 11.25H14.2471C15.8625 12.5754 16.875 14.5582 16.875 16.7801C16.875 17.2301 16.7414 17.6449 16.5234 18H21.375C21.9973 18 22.5 17.4937 22.5 16.8434C22.5 13.7672 19.9828 11.25 16.8434 11.25ZM15.1875 9C17.3637 9 19.125 7.23867 19.125 5.0625C19.125 2.88633 17.3637 1.125 15.1875 1.125C14.3047 1.125 13.4986 1.42576 12.8419 1.91637C13.2469 2.69402 13.5 3.56484 13.5 4.5C13.5 5.74875 13.0806 6.89555 12.3894 7.82965C13.1027 8.55 14.0906 9 15.1875 9Z"
				id="Group"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

Group.propTypes = {
	color: PropTypes.string,
};

export default Group;
